var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px", height: "60%" },
          attrs: {
            title: _vm.title,
            width: 800,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.isReadOnly
                ? _c(
                    "a-button",
                    { key: "back", on: { click: _vm.handleCancel } },
                    [_vm._v("\n        取消\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "属性名",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: [
                              "attributeName",
                              _vm.validatorRules.attributeName,
                            ],
                            expression:
                              "[ 'attributeName', validatorRules.attributeName]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入属性名" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "属性值",
                      },
                    },
                    [
                      _c(
                        "a-tabs",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.activeKey,
                            callback: function ($$v) {
                              _vm.activeKey = $$v
                            },
                            expression: "activeKey",
                          },
                        },
                        [
                          _c(
                            "a-tab-pane",
                            {
                              key: "1",
                              attrs: { tab: "标签模式", forceRender: "" },
                            },
                            [
                              _vm._l(_vm.tags, function (tag, index) {
                                return [
                                  _c(
                                    "a-tag",
                                    {
                                      key: tag,
                                      staticStyle: { "margin-bottom": "10px" },
                                      attrs: { color: "blue", closable: true },
                                      on: { close: () => _vm.handleClose(tag) },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(tag) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              }),
                              _vm.inputVisible
                                ? _c("a-input", {
                                    ref: "input",
                                    style: { width: "150px" },
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      value: _vm.inputValue,
                                    },
                                    on: {
                                      change: _vm.handleInputChange,
                                      blur: _vm.handleInputConfirm,
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.handleInputConfirm.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  })
                                : _c(
                                    "a-tag",
                                    {
                                      staticStyle: {
                                        background: "#fff",
                                        borderStyle: "dashed",
                                      },
                                      on: { click: _vm.showInput },
                                    },
                                    [
                                      _c("a-icon", { attrs: { type: "plus" } }),
                                      _vm._v(" 请输入属性值\n              "),
                                    ],
                                    1
                                  ),
                            ],
                            2
                          ),
                          _c(
                            "a-tab-pane",
                            {
                              key: "2",
                              attrs: { tab: "文字模式", forceRender: "" },
                            },
                            [
                              _c("a-textarea", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: [
                                      "attributeValue",
                                      _vm.validatorRules.attributeValue,
                                    ],
                                    expression:
                                      "[ 'attributeValue', validatorRules.attributeValue]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { rows: 8, placeholder: "请输入属性值" },
                                on: { change: _vm.handleValueChange },
                              }),
                              _vm._v(
                                "\n              注意：属性值请用竖线隔开，比如：红色|橙色|黄色|绿色\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }